import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  TextField,
  Button,
  Snackbar,
  Alert
} from '@mui/material'
import { ContentCopy } from '@mui/icons-material'
import { Theme, useTheme } from '@mui/material/styles'
import { usePublisherInfo } from '../hooks/usePublisherInfo'
import { useState } from 'react'
import { RSSUrlBuilder } from '../functions/RSSUrlBuilder'

const styles = {
  urlContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  urlBox: {
    display: 'flex',
    gap: 1,
    width: '100%',
    alignItems: 'center',
    flexDirection: { xs: 'column', sm: 'row' }
  },
  textField: (theme: Theme) => ({
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.02)',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider
    }
  }),
  copyButton: {
    minWidth: '100px',
    backgroundColor: '#00bcd4',
    '&:hover': {
      backgroundColor: '#00a4b9'
    },
    alignSelf: { xs: 'stretch', sm: 'auto' }
  },
  alert: {
    width: '100%'
  }
}

export const ArticleRSSFeed = () => {
  const theme = useTheme()
  const { publisher } = usePublisherInfo()
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const URLs = RSSUrlBuilder(publisher)

  const handleCopy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      setOpenSnackbar(true)
    } catch (err) {
      console.error('Failed to copy text: ', err)
    }
  }

  return (
    <Card>
      <CardHeader
        title="Article RSS Feed"
        data-testid="article-rss-feed-header"
      />

      <CardContent>
        <Typography variant="body1" gutterBottom>
          All articles written for your shop in a simple RSS feed format.
        </Typography>

        <Typography variant="h5" gutterBottom>
          Installation Instructions
        </Typography>

        <Typography variant="body1" gutterBottom>
          Please find your RSS Feed URLs below. These URLs are specific to you.
        </Typography>

        <Box sx={styles.urlContainer}>
          {URLs.map((url, index) => (
            <Box key={index} sx={styles.urlBox}>
              <TextField
                fullWidth
                value={url}
                variant="outlined"
                size="small"
                InputProps={{
                  readOnly: true,
                  sx: styles.textField(theme)
                }}
              />

              <Button
                variant="contained"
                onClick={() => handleCopy(url)}
                startIcon={<ContentCopy />}
                sx={styles.copyButton}
              >
                Copy
              </Button>
            </Box>
          ))}
        </Box>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={2000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity="success"
            sx={styles.alert}
          >
            URL copied to clipboard!
          </Alert>
        </Snackbar>
      </CardContent>
    </Card>
  )
}
